import BoxCreditProposal from '../../../../../pages/vip/features/box-credit-proposal';

export default BoxCreditProposal;
